<template> 
<div>
    <page-padding>
      <div v-if="!hasCalendar">{{$t('language.no_calendar')}}</div>
    </page-padding>
    
    <!--
      infinite list werkt minder met de kalender. Er kunnen bijvoorbeeld 1000 items op 1 datum staat.
      de datum is in principe het item. Dat is het root object.
    -->

    <infinite-list v-if="hasCalendar" :list='calendar[cal_id+"calendar"].dates'> 
      <template v-slot:default="date">  
          <head-calendar class="head" :title="translateHeadDate(date.item.title)"/>
          <button-calendar :date="date.item.title" :key="item.id" v-for="(item) in date.item.items" :item_id="item.id" :image-url="item.icon"  :title="getCalendarTitle(item)" :subtitle="item.descr"/>
      </template>
  </infinite-list>
</div>
</template>

<script>

import { mapState } from 'vuex';
import HeadCalendar from './/HeadCalendar';
import ButtonCalendar from './ButtonCalendar';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-calendar',
  props:{
    cal_id:{default:0},
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    HeadCalendar,
    ButtonCalendar,
    PagePadding,
    InfiniteList,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    getCalendarTitle(item){
      var start_time=(item.start_time!="" && item.start_time!=" " && item.start_time) ? item.start_time: "";
      var end_time=(item.end_time!="" && item.end_time!=" " && item.end_time) ? item.end_time: "";
      var separator=end_time ? " - " : "";
      return start_time+separator+end_time+" "+item.title;
    },
    translateHeadDate(title){
        var a=title.split(",");
        var day=a.shift();
        var day_translate=this.$t("language."+day.toLowerCase())
        return day_translate+","+a.join();
    },
    load_calendar(){
      this.emitLoadStart();
    
      this.$store.dispatch('get_calendar',{store_key:this.cal_id+"calendar", id:this.cal_id}).then(()=>{
        this.emitLoadEnd();
      })
     
    },
  },
  computed:{
    ...mapState([
       'calendar',
       ]),
       hasCalendar:function(){
       
        var store_key=this.cal_id+"calendar";
         if(this.calendar[store_key]){

           return this.calendar[store_key].dates ? this.calendar[store_key].dates.length : false;
         }else{
           return false;
         }
        
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_calendar)
  },
  mounted:function(){
   this.load_calendar();
    eventBus.$on("RELOAD_FROM_PULL",this.load_calendar)
  },  
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head{
 
  border-top:1px solid #707070;
  border-bottom:1px solid #707070;
}


</style>

